import React, { useEffect } from 'react';
import { useGameSettings } from './slotGame/slotData';

export const Navbar = ({ balance, bet, win, setShowPaylines, turboOn, setTurboOn, setShowPayTable, setShowVolume, setShowSettings, handleSpinCallback, winLineCount, setShowAutoPlay, stopAutoPlay, autoPlay, countAutoPlay, setShowBetMultiplier, setBetAction, playFreeSpin, freeSpinAutoPlayCount, setSoundEffectFile, activeModel, setActiveModel, notificationMsg }) => {

    const { settingsButtonUrl, infoButtonUrl, soundButtonUrl, turboButtonUrl, turboOnButtonUrl, payLinesButtonUrl, plusButtonUrl, minusButtonUrl, spinButtonUrl, autoPlayButtonUrl, normalButtonAudioUrl } = useGameSettings()

    useEffect(() => {
        if (countAutoPlay === 0) {
            stopAutoPlay()
        }
        if (bet > balance && autoPlay) {
            stopAutoPlay()
        }
        if (autoPlay && notificationMsg === "Auto Spin limit exceeded, so auto spin has been turned off!") {
            stopAutoPlay()
        }
    }, [autoPlay, balance, bet, countAutoPlay, notificationMsg, stopAutoPlay])

    const playButtonClickSoundEffect = () => {
        return setSoundEffectFile(`${normalButtonAudioUrl}?t=${Date.now()}`)
    }


    if (playFreeSpin) {
        return (
            <div
                className="w-full h-full xs:mb-1 sm:mb-2 md:mb-3 lg:mb-4 xl:mb-5 2xl:mb-6 3xl:mb-6 text-white flex flex-wrap items-end justify-between xs:mx-5 md:mx-7 lg:mx-10 xl:mx-14 3xl:mx-28"
            >
                <div className='flex flex-row justify-center items-center xs:mt-2 md:mt-3'>
                    <div className='flex flex-col m-2 xs:text-xs md:text-md lg:text-lg 2xl:text-xl 3xl:text-3xl'>
                        <div className='flex flex-row'>
                            BALANCE: <span className='text-[#00E701] pl-1'>{balance?.toFixed(2)}</span>
                        </div>
                        <div className='flex flex-row'>
                            BET: <span className='text-[#F5D72E] pl-1'>{bet?.toFixed(2)}</span>
                        </div>
                    </div>
                </div>
                <div className='h-[50%] flex items-center font-bold xs:text-lg md:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-5xl'>
                    PLACE YOUR BETS!
                </div>
                <div className='xs:text-lg md:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-5xl flex flex-row items-center justify-center'>
                    <span>Free Spin</span>
                    <div
                        className='flex items-center justify-center mx-2 bg-[#181D29] bg-opacity-40 xs:w-6 xs:h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 xl:w-16 xl:h-16 2xl:w-20 2xl:h-20 3xl:w-28 3xl:h-28 z-0 bg-cover bg-center bg-no-repeat border border-white rounded-full xs:py-2 lg:py-6 2xl:py-10 font-bold xs:text-xs md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl'
                    >
                        {freeSpinAutoPlayCount}
                    </div>
                    <span>Left</span>
                </div>
            </div>
        )
    }

    return (
        <div
            className="w-full h-full text-white flex flex-wrap items-center justify-between xs:mx-2 md:mx-3 lg:mx-10 xl:mx-14 3xl:mx-24"
        >
            <div className='flex flex-row justify-center items-center xs:mt-2 md:mt-3 w-[25%]'>
                <div className='flex flex-col items-center justify-between h-full m-2 '>
                    <div
                        className="xs:w-4 xs:h-4 md:w-6 md:h-6 2xl:w-9 2xl:h-9 3xl:w-11 3xl:h-11 bg-cover bg-no-repeat"
                        style={{
                            backgroundImage: `url(${settingsButtonUrl})`,
                            backgroundSize: "100% 100%"
                        }}
                        onClick={() => {
                            if (activeModel === null) {
                                setActiveModel("Settings")
                                setShowSettings(true);
                                playButtonClickSoundEffect()
                            }
                        }}
                    ></div>
                    <div
                        className="xs:w-4 xs:h-4 md:w-6 md:h-6 2xl:w-9 2xl:h-9 3xl:w-11 3xl:h-11 bg-cover bg-no-repeat"
                        style={{
                            backgroundImage: `url(${soundButtonUrl})`,
                            backgroundSize: "100% 100%"
                        }}
                        onClick={() => {
                            if (activeModel === null) {
                                setActiveModel("Sound")
                                setShowVolume(true);
                                playButtonClickSoundEffect()
                            }
                        }}
                    ></div>
                </div>
                <div
                    className='flex items-center justify-center h-full xs:w-5 xs:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 2xl:w-9 2xl:h-9 3xl:w-11 3xl:h-11 bg-cover bg-no-repeat xs:m-0 md:m-2'
                    style={{
                        backgroundImage: `url(${infoButtonUrl})`,
                        backgroundSize: "100% 100%"
                    }}
                    onClick={() => {
                        if (activeModel === null) {
                            setActiveModel("Info")
                            setShowPayTable(true);
                            playButtonClickSoundEffect()
                        }
                    }}
                >
                </div>
                <div className='flex flex-col m-2 xs:text-xs md:text-md lg:text-lg 2xl:text-xl 3xl:text-3xl'>
                    <div className='flex flex-row'>
                        BALANCE: <span className='text-[#00E701] pl-1'>{balance.toFixed(2)}</span>
                    </div>
                    <div className='flex flex-row'>
                        BET: <span className='text-[#F5D72E] pl-1'>{bet?.toFixed(2)}</span>
                    </div>
                </div>
            </div>
            {notificationMsg !== "" ?
                <div className='font-bold xs:text-[0.5rem] md:text-[0.6rem] lg:text-base xl:text-lg 2xl:text-xl 3xl:text-2xl w-[50%]'>
                    {notificationMsg}
                </div>
                :
                <div className='font-bold xs:text-lg md:text-xl xl:text-3xl 2xl:text-3xl 3xl:text-5xl w-[50%]'>
                    {win
                        ? `You Won ${win.toFixed(2)} with ${winLineCount} lines.`
                        : "PLACE YOUR BETS!"
                    }
                </div>
            }
            <div className='flex flex-row items-center justify-center w-[25%]'>
                <div
                    className='flex items-center justify-center h-full xs:w-5 xs:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 2xl:w-14 2xl:h-14 bg-cover bg-no-repeat'
                    style={{
                        backgroundImage: `url(${minusButtonUrl})`,
                        backgroundSize: "100% 100%"
                    }}
                    onClick={() => {
                        if (activeModel === null) {
                            setActiveModel("minus bet model")
                            setShowBetMultiplier(true)
                            setBetAction("minus")
                            playButtonClickSoundEffect()
                        }
                    }}
                ></div>
                <div className='flex flex-col items-center justify-center xs:-mt-6 md:-mt-10 xl:-mt-14 3xl:-mt-16'>
                    {autoPlay ?
                        <>
                            <div
                                className='flex items-center justify-center bg-[#181D29] bg-opacity-40 xs:w-12 xs:h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 2xl:w-32 2xl:h-32 3xl:w-40 3xl:h-40 z-0 bg-cover bg-center bg-no-repeat border border-white rounded-full xs:py-2 lg:py-6 2xl:py-10 font-bold xs:text-xs md:text-md lg:text-3xl 2xl:text-4xl'
                                style={{
                                    backgroundImage: `${countAutoPlay === -1 ? "url('/infinity-large.png')" : ""}`,
                                    backgroundSize: "80% 80%",
                                    filter: "drop-shadow(0px 4px 6px rgba(0, 0, 1, 1))",
                                }}
                            >
                                {countAutoPlay >= 0 ? countAutoPlay : null}
                            </div>
                            <div
                                className='flex items-center justify-center h-full w-full bg-[#4B4217] border border-white rounded-2xl xs:px-1 md:px-3 bg-cover bg-no-repeat mx-2 -mt-2 z-2 xs:text-xs md:text-md lg:text-lg 2xl:text-2xl 3xl:text-3xl font-bold'
                                onClick={() => {
                                    playButtonClickSoundEffect()
                                    stopAutoPlay()
                                }}
                            >
                                Stop
                            </div>
                        </>
                        :
                        <>
                            <div
                                className='flex items-center justify-center h-full xs:w-12 xs:h-12 sm:w-14 sm:h-14 md:w-16 md:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 2xl:w-32 2xl:h-32 3xl:w-40 3xl:h-40 bg-cover bg-no-repeat mx-2 z-0'
                                style={{
                                    backgroundImage: `url(${spinButtonUrl})`,
                                    backgroundSize: "100% 100%",
                                    filter: "drop-shadow(0px 4px 6px rgba(0, 0, 0, 1))",
                                }}
                                onClick={() => {
                                    if (activeModel === null) {
                                        setActiveModel("Spin");
                                        playButtonClickSoundEffect()
                                        handleSpinCallback()
                                    }
                                }}
                            ></div>
                            <div
                                className='flex items-center justify-center h-full xs:w-12 xs:h-3 sm:w-14 md:w-16 md:h-6 xl:w-24 xl:h-8 2xl:w-32 2xl:h-10 3xl:w-40 3xl:h-14 bg-cover bg-no-repeat mx-2 -mt-2 z-2'
                                style={{
                                    backgroundImage: `url(${autoPlayButtonUrl})`,
                                    backgroundSize: "100% 100%"
                                }}
                                onClick={() => {
                                    if (activeModel === null) {
                                        setActiveModel("Auto-play")
                                        setShowAutoPlay(true);
                                        playButtonClickSoundEffect()
                                    }
                                }}
                            ></div>
                        </>
                    }
                </div>
                <div
                    className='flex items-center justify-center h-full xs:w-5 xs:h-5 md:w-6 md:h-6 lg:w-8 lg:h-8 xl:w-10 xl:h-10 2xl:w-14 2xl:h-14 bg-cover bg-no-repeat'
                    style={{
                        backgroundImage: `url(${plusButtonUrl})`,
                        backgroundSize: "100% 100%"
                    }}
                    onClick={() => {
                        if (activeModel === null) {
                            setActiveModel("Plus bet model")
                            setShowBetMultiplier(true)
                            setBetAction("Plus")
                            playButtonClickSoundEffect()
                        }
                    }}
                ></div>
                <div
                    className='flex items-center justify-center h-full xs:w-5 xs:h-5 md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 2xl:w-16 2xl:h-16 3xl:w-20 3xl:h-20 bg-cover bg-no-repeat xs:m-1 lg:m-2'
                    style={{
                        backgroundImage: `url(${turboOn ? turboOnButtonUrl : turboButtonUrl || "/turbo.png"})`,
                        backgroundSize: "100% 100%"
                    }}
                    onClick={() => {
                        if (activeModel === null) {
                            setTurboOn(!turboOn);
                            playButtonClickSoundEffect()
                        }
                    }}
                ></div>
                <div
                    className='flex items-center justify-center h-full xs:w-5 xs:h-5 md:w-8 md:h-8 lg:w-10 lg:h-10 xl:w-12 xl:h-12 2xl:w-16 2xl:h-16 3xl:w-20 3xl:h-20 bg-cover bg-no-repeat xs:m-1 lg:m-2'
                    style={{
                        backgroundImage: `url(${payLinesButtonUrl})`,
                        backgroundSize: "100% 100%"
                    }}
                    onClick={() => {
                        if (activeModel === null) {
                            setActiveModel("Paylines")
                            setShowPaylines(true);
                            playButtonClickSoundEffect()
                        }
                    }}
                ></div>
            </div>
        </div>
    );
};
